import {
  TrafficSourcesActions,
  CREATE_TRAFFIC_SOURCE_FAILURE,
  CREATE_TRAFFIC_SOURCE_REQUEST,
  CREATE_TRAFFIC_SOURCE_SUCCESS,
  DELETE_TRAFFIC_SOURCE_FAILURE,
  DELETE_TRAFFIC_SOURCE_REQUEST,
  DELETE_TRAFFIC_SOURCE_SUCCESS,
  FETCH_SSPS_FAILURE,
  FETCH_SSPS_REQUEST,
  FETCH_SSPS_SUCCESS,
  FETCH_TRAFFIC_SOURCE_BY_ID_FAILURE,
  FETCH_TRAFFIC_SOURCE_BY_ID_REQUEST,
  FETCH_TRAFFIC_SOURCE_BY_ID_SUCCESS,
  FETCH_TRAFFIC_SOURCES_FAILURE,
  FETCH_TRAFFIC_SOURCES_REQUEST,
  FETCH_TRAFFIC_SOURCES_SUCCESS,
  REMOVE_TRAFFIC_SOURCE_BY_ID_FROM_STATE,
  EDIT_TRAFFIC_SOURCE_FAILURE,
  EDIT_TRAFFIC_SOURCE_REQUEST,
  EDIT_TRAFFIC_SOURCE_SUCCESS,
} from './traffic-sources.actions';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import _ from 'lodash';

export interface TrafficSourcesState {
  trafficSources: any[];
  isTrafficSourcesLoading: boolean;
  editedTrafficSource: any;
  isEditedTrafficSourceLoading: boolean;
  ssps: any[];
  isSspsLoading: boolean;
  error?: any;
}

const initialState: TrafficSourcesState = {
  trafficSources: null,
  isTrafficSourcesLoading: false,
  editedTrafficSource: null,
  isEditedTrafficSourceLoading: false,
  ssps: null,
  isSspsLoading: false,
  error: null
};

export function trafficSourcesReducer(state = initialState, action: TrafficSourcesActions) {
  switch (action.type) {
    case FETCH_TRAFFIC_SOURCES_REQUEST:
      return {...state, isTrafficSourcesLoading: true};
    case FETCH_TRAFFIC_SOURCES_SUCCESS:
      return {...state, trafficSources: action.payload.trafficSources, isTrafficSourcesLoading: false};
    case FETCH_TRAFFIC_SOURCES_FAILURE:
      return {...state, isTrafficSourcesLoading: false, error: action.payload.error};

    case FETCH_TRAFFIC_SOURCE_BY_ID_REQUEST:
      return {...state, isEditedTrafficSourceLoading: true};
    case FETCH_TRAFFIC_SOURCE_BY_ID_SUCCESS:
      return {...state, editedTrafficSource: action.payload.editedTrafficSource, isEditedTrafficSourceLoading: false};
    case FETCH_TRAFFIC_SOURCE_BY_ID_FAILURE:
      return {...state, isEditedTrafficSourceLoading: false, error: action.payload.error};
    case REMOVE_TRAFFIC_SOURCE_BY_ID_FROM_STATE:
      return {...state, editedTrafficSource: null};
    case CREATE_TRAFFIC_SOURCE_REQUEST:
      return {...state, isEditedTrafficSourceLoading: true};
    case CREATE_TRAFFIC_SOURCE_SUCCESS:
      if (!state.trafficSources) {
        state = {...state,  trafficSources: [action.payload.editedTrafficSource]};
      } else {
        state = {...state, trafficSources: [...state.trafficSources, action.payload.editedTrafficSource]};
      }
      return {
        ...state,
        trafficSources: [...state.trafficSources.slice()],
        editedTrafficSource: action.payload.editedTrafficSource,
        isEditedTrafficSourceLoading: false
      };
    case CREATE_TRAFFIC_SOURCE_FAILURE:
      return {...state, isEditedTrafficSourceLoading: false, error: action.payload.error};
    case EDIT_TRAFFIC_SOURCE_REQUEST:
      return {...state, isEditedTrafficSourceLoading: true};
    case EDIT_TRAFFIC_SOURCE_SUCCESS:
      const trafficSourceToUpdateIndex = _.findIndex(state.trafficSources, {trafficSourceId: action.payload.editedTrafficSource.trafficSourceId});
      return {
        ...state,
        editedTrafficSource: action.payload.editedTrafficSource,
        trafficSources: [...state.trafficSources.slice(0, trafficSourceToUpdateIndex),
          {
            ...action.payload.editedTrafficSource
          },
          ...state.trafficSources.slice(trafficSourceToUpdateIndex + 1)
        ],
        isEditedTrafficSourceLoading: false
      };
    case EDIT_TRAFFIC_SOURCE_FAILURE:
      return {...state, isEditedTrafficSourceLoading: false, error: action.payload.error};

    case DELETE_TRAFFIC_SOURCE_REQUEST:
      return {...state, isEditedTrafficSourceLoading: true};
    case DELETE_TRAFFIC_SOURCE_SUCCESS:
      const trafficSourceToDeleteIndex = _.findIndex(state.trafficSources, {trafficSourceId: action.payload.deleteTrafficSourceId});
      return {
        ...state,
        trafficSources: [...state.trafficSources.slice(0, trafficSourceToDeleteIndex), ...state.trafficSources.slice(trafficSourceToDeleteIndex + 1)],
        isEditedTrafficSourceLoading: false
      };
    case DELETE_TRAFFIC_SOURCE_FAILURE:
      return {...state, isEditedTrafficSourceLoading: false, error: action.payload.error};

    case FETCH_SSPS_REQUEST:
      return {...state, isSspsLoading: true};
    case FETCH_SSPS_SUCCESS:
      return {...state, ssps: action.payload.ssps, isSspsLoading: false};
    case FETCH_SSPS_FAILURE:
      return {...state, isSspsLoading: false, error: action.payload.error};
    default:
      return state;
  }
}

export const getTrafficSourcesState = createFeatureSelector<TrafficSourcesState>('trafficSources');
export const getTrafficSourcesLoading = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.isTrafficSourcesLoading);
export const getTrafficSources = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.trafficSources);
export const getTrafficSourceByIdLoading = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.isEditedTrafficSourceLoading);
export const getTrafficSourceById = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.editedTrafficSource);
export const getTrafficSourcesSspsLoading = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.isSspsLoading);
export const getTrafficSourcesSsps = createSelector(getTrafficSourcesState, (state: TrafficSourcesState) => state.ssps);


